export default {
  apiKey: 'AIzaSyC-PdaX6yakdZx-qe-2WXk2_z-QwS2Stao',
  authDomain: 'test-project-8cc4b.firebaseapp.com',
  databaseURL: 'https://test-project-8cc4b.firebaseio.com',
  projectId: 'test-project-8cc4b',
  storageBucket: 'test-project-8cc4b.appspot.com',
  messagingSenderId: '951703963249',
  appId: '1:951703963249:web:e18198f68aeb0f7951bdd0',
  measurementId: 'G-0HDWG2WEQF',
};
